import { Theme, makeStyles } from '@material-ui/core';
import { emphasize } from '@material-ui/core/styles';

// Locking the chip background suppresses MUI Chip's only focus indicator
// (a background shade change), so keyboard focus needs an explicit ring.
const focusRing = (theme: Theme) => ({
  '&:focus-visible': {
    outline: `${theme.spacing(0.25)}px solid var(--bui-ring)`,
    outlineOffset: theme.spacing(0.25),
  },
});

const lockBackground = (theme: Theme, bg: string) => ({
  border: 'none !important',
  backgroundColor: `${bg} !important`,
  '&:hover, &:focus, &:active': {
    backgroundColor: `${bg} !important`,
  },
  ...focusRing(theme),
});

export const useFilterChipStyles = makeStyles(theme => ({
  inactive: lockBackground(
    theme,
    emphasize(theme.palette.background.default, 0.08),
  ),
  active: lockBackground(
    theme,
    emphasize(theme.palette.background.default, 0.18),
  ),
  focusRing: focusRing(theme),
}));
